import { createFileRoute } from "@tanstack/react-router";
import HusselenVsTossenVsRacketTrekken from "@/pages/HusselenVsTossenVsRacketTrekken";

export const Route = createFileRoute("/husselen-vs-tossen-vs-racket-trekken")({
  head: () => ({
    meta: [
      { title: "Husselen vs tossen vs racket trekken: het verschil uitgelegd | De Hussel App" },
      { name: "description", content: "Husselen, tossen en racket trekken worden vaak door elkaar gebruikt. Lees de exacte verschillen, overeenkomsten en welke speelvorm bij jouw tennisclub past." },
      { property: "og:title", content: "Husselen vs tossen vs racket trekken: het verschil uitgelegd | De Hussel App" },
      { property: "og:description", content: "Husselen, tossen en racket trekken worden vaak door elkaar gebruikt. Lees de exacte verschillen, overeenkomsten en welke speelvorm bij jouw tennisclub past." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/husselen-vs-tossen-vs-racket-trekken" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/husselen-vs-tossen-vs-racket-trekken" }],
  }),
  component: HusselenVsTossenVsRacketTrekken,
});
